import { CustomList } from 'components/index';
import React from 'react'
import { RenderProfile } from "components/render-profile";
import UnreviewedHoursByJCFilters from '@/modules/reports/timesheet/unreviewed-by-jc/filters';


const UnreviewedHoursByJC = () => {

    const columns = [
        {
            header: "Employee",
            id: "employee",
            accessorKey: "employee",
            cell: ({ getValue }) => {
                return <RenderProfile user={getValue()} />;
            },
        },
        {
            header: "Unreviewed Hours",
            accessorKey: "pending_review_hours",
            id: "pending_review_hours",
        },
    ];

    return (
        <CustomList
            title={"Unreviewed Hours By JC"}
            endPoint="custom/coordinators-pending-hours"
            renderFilters={UnreviewedHoursByJCFilters}
            columns={columns}
            showSearch={false}
            hidePagination={true}
            storageKey={`unreviewed-hours-by-jc`}
            teleportFilters={true}
        />
    )
}

export default UnreviewedHoursByJC